import httpClient from 'shared/lib/httpClient';
import { parseServiceClassList } from '../schemas/MasterDataSchema';

export const getServiceClassList = async (signal) => {
  const response = await httpClient.get('/service-classes', { signal });
  return parseServiceClassList(response?.data);
};
